export default __webpack_public_path__ + "static/media/Balasundaram.9e51959a.png";